import Backbone from 'backbone'
import _ from 'lodash'
import $ from 'jquery'
import appDisplay from 'scoreboard/components/app-display'
import i18n from 'scoreboard/components/i18n'
import User from '../user'
import DataPreview from 'scoreboard/components/data-preview'
import Results from 'scoreboard/components/import-results-dialog'

var ImportUsersPreview = DataPreview.extend({

	className: 'import-users-preview',

	/**
	 * @param {Array} [options.files]
	 */
	initialize(options = {}) {
		this.preview = options.preview
		this.preview.title = i18n.get('admin.import.users')
		this.preview.label = _.escape(_.get(options, 'files[0].name', ''))
		DataPreview.prototype.initialize.call(this, _.pick(options, 'preview', 'files', 'wizard'))
	},

	submit(e) {
		e.preventDefault()

		if (this.test()) {
			return false
		}
		this.formView._setSubmitting(true)
		this.formView.primaryButton.loading()

		// We still have the file from the file-input we used in upload-users-form,
		// so we don't need another file-input; we can just submit the same file.
		// We do have to re-upload the file, though, since we don't want to keep
		// that state on the server.
		var form = new FormData()
		form.append('file', this.options.files[0])

		$.ajax({
			url: 'api/admin/users/import',
			method: 'POST',
			data: form,
			contentType: false,
			processData: false,
			success: this._onUploadFinished.bind(this),
			error: this._onUploadError.bind(this)
		})
	},

	// executed when upload is done
	_onUploadFinished(results) {
		appDisplay.replaceDialog(new Results({
			results,
			countMessageKey: 'admin.import.user'
		}))

		if (results && results.importedItems.length > 0) {
			Backbone.trigger('add:domain-objects', results.importedItems.map(function (user) {
				return new User(user)
			}))
		}
	},

	_onUploadError(xhr) {
		this.formView.error(xhr)
	}
})

export default ImportUsersPreview

ImportUsersPreview.__filename__ = 'admin/principals/users/import/import-users-preview.js'
